<script>
	import { colorMain } from "../stores.js";
	import Icon from "@iconify/svelte";
	import yOutline from "@iconify/icons-healthicons/y-outline";

	let iconColor = "white";
</script>

<nav class="yourfeed-header" style="background-color: {$colorMain};">
	<a href="/">
		<span class="icon"
			><Icon
				icon={yOutline}
				width="21"
				color={iconColor}
				inline={false}
			/></span
		>
	</a>
</nav>

<style>
	.yourfeed-header {
		font-family: Verdana, sans-serif;
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		padding: 16px 13% 16px 13%;
		line-height: 34px;
		/* background-color: #32292f; */
		color: white;
		z-index: 1;
	}
	.icon {
		vertical-align: middle;
		position: fixed;
		top: 5px;
		margin: 0 0 0 -5px;
		padding: 0;
		height: 21px;
		width: auto;
	}
</style>
